import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useCategories } from "../../hooks/transactions";

interface CategorySelectProps {
  value: string | null;
  direction: "INCOME" | "EXPENSE" | "TRANSFER";
  onChange: (id: string | null) => void;
}

export function CategorySelect({ value, direction, onChange }: CategorySelectProps) {
  const { t } = useTranslation();
  const { data } = useCategories(direction);
  const options = data?.categories ?? [];
  return (
    <div className="space-y-1">
      <select
        className="w-full border rounded px-2 py-1"
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value || null)}
      >
        <option value="">
          {t("cashflow.form.category.placeholder", { defaultValue: "— Kategorie waehlen —" })}
        </option>
        {options.map((c) => (
          <option key={c.id} value={c.id}>
            {c.fullPath}
          </option>
        ))}
      </select>
      <Link
        to="/categories"
        className="text-xs text-blue-600 underline"
        target="_blank"
        rel="noreferrer"
      >
        {t("cashflow.form.category.manage_link", { defaultValue: "Kategorien verwalten" })}
      </Link>
    </div>
  );
}
